<div class="confirm-dialog-wrapper">
  <div class="dialog-header">
    <div class="warning-icon-wrap">
      <mat-icon>warning_amber</mat-icon>
    </div>
    <div>
      <h2 class="dialog-title">Confirm Action</h2>
      <p class="dialog-subtitle">Please confirm to proceed</p>
    </div>
  </div>

  <div class="dialog-body">
    <p class="confirm-message">
      {{ obj?.message ? obj.message : 'Are you sure you want to proceed with this deletion? This action cannot be undone.' }}
    </p>
  </div>

  <div class="dialog-actions">
    <button 
      mat-stroked-button 
      (click)="dialogRef.close(false)" 
      class="cancel-btn">
      {{ obj?.buttonText?.no || 'Cancel' }}
    </button>
    <button 
      mat-flat-button 
      (click)="dialogRef.close(true)" 
      class="confirm-btn">
      <mat-icon>delete</mat-icon>
      {{ obj?.buttonText?.yes || 'Delete' }}
    </button>
  </div>
</div>